import { useCallback } from 'react';
import sendUploadAnalytics from '@/utils/analytics/sendUploadAnalytics';

interface UseMediaUploadOptions {
  uploadMedia: (file: File, id: string) => Promise<string | null>;
  isAuthorized: boolean | undefined;
  addPendingUpload: (upload: { id: string; file: File }) => void;
}

const useMediaUpload = ({
  uploadMedia,
  isAuthorized,
  addPendingUpload,
}: UseMediaUploadOptions) => {
  const handleMediaUpload = useCallback(
    async (id: string, file: File): Promise<boolean> => {
      if (!isAuthorized) {
        addPendingUpload({ id, file });
        return true;
      }

      const cdnUrl = await uploadMedia(file, id);
      if (cdnUrl) sendUploadAnalytics();
      return true;
    },
    [uploadMedia, isAuthorized, addPendingUpload]
  );

  return { handleMediaUpload };
};

export default useMediaUpload;
